/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_SectionsInputs */

const en_mobile_player_sections = /** @type {(inputs: Mobile_Player_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

const es_mobile_player_sections = /** @type {(inputs: Mobile_Player_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secciones`)
};

/**
* | output |
* | --- |
* | "Sections" |
*
* @param {Mobile_Player_SectionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_sections = /** @type {((inputs?: Mobile_Player_SectionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_SectionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_sections(inputs)
	return en_mobile_player_sections(inputs)
});